module.exports = __webpack_public_path__ + "img/icon_request_new_loan.97af699e.svg";